export default {
	Menu: {
		DASHBOARD: 'Tổng quan',
		TAXDEC: 'Khai thuế',
		TAXPAY: 'Nộp thuế',
		REPORTS: 'Báo cáo',
		NOTIFICATION: 'Thông báo từ CQT',
		SERVICETVAN: 'Dịch vụ T-VAN MISA',
		USERMANAGER: 'Quản lý người dùng',
		TAXPAYERINFO: 'Thông tin người nộp thuế',
		HISTORY: 'Nhật ký truy cập',
		SYSTEM: 'Hệ thống',
		taxreturnsubmission: 'Tờ khai',
		taxregis: 'Đăng ký tờ khai',
		taxreghaunt: 'Đăng ký địa bàn vãng lai',
		taxdeclarationprocedure: 'Quy trình',
		SettingUSBToken: 'Thiết lập chữ ký số',
		ContactEmail: 'Email nhận thông báo',
		OptionsSetings: 'Tùy chọn',
		Resources: 'Tài nguyên',
		taxpaymentprocedure: 'Quy trình',
		TaxPaper: 'Giấy nộp tiền',
		TAXRETURNSUBMISSIONISPAIDLIST: 'Bảng kê tờ khai đã nộp',
		MUSTPAYTAXAMOUNTREPORT: 'Bảng kê số thuế đã nộp',
		StateBudget: 'Thiết lập khoản nộp NSNN'
	},
	Title: {}
};
